/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TimeRangeDto } from './TimeRangeDto';
import {
    TimeRangeDtoFromJSON,
    TimeRangeDtoFromJSONTyped,
    TimeRangeDtoToJSON,
} from './TimeRangeDto';

/**
 * 
 * @export
 * @interface OpeningHoursDto
 */
export interface OpeningHoursDto {
    /**
     * 
     * @type {string}
     * @memberof OpeningHoursDto
     */
    day: OpeningHoursDtoDayEnum;
    /**
     * 
     * @type {TimeRangeDto}
     * @memberof OpeningHoursDto
     */
    timeRange?: TimeRangeDto;
    /**
     * 
     * @type {boolean}
     * @memberof OpeningHoursDto
     */
    closed: boolean;
}


/**
 * @export
 */
export const OpeningHoursDtoDayEnum = {
    MONDAY: 'MONDAY',
    TUESDAY: 'TUESDAY',
    WEDNESDAY: 'WEDNESDAY',
    THURSDAY: 'THURSDAY',
    FRIDAY: 'FRIDAY',
    SATURDAY: 'SATURDAY',
    SUNDAY: 'SUNDAY'
} as const;
export type OpeningHoursDtoDayEnum = typeof OpeningHoursDtoDayEnum[keyof typeof OpeningHoursDtoDayEnum];


/**
 * Check if a given object implements the OpeningHoursDto interface.
 */
export function instanceOfOpeningHoursDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "day" in value;
    isInstance = isInstance && "closed" in value;

    return isInstance;
}

export function OpeningHoursDtoFromJSON(json: any): OpeningHoursDto {
    return OpeningHoursDtoFromJSONTyped(json, false);
}

export function OpeningHoursDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OpeningHoursDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'day': json['day'],
        'timeRange': !exists(json, 'timeRange') ? undefined : TimeRangeDtoFromJSON(json['timeRange']),
        'closed': json['closed'],
    };
}

export function OpeningHoursDtoToJSON(value?: OpeningHoursDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'day': value.day,
        'timeRange': TimeRangeDtoToJSON(value.timeRange),
        'closed': value.closed,
    };
}

